module.exports = __webpack_public_path__ + "static/logo-email-132608131cc165fe85f0def17fd96cd2.png";